import { render, staticRenderFns } from "./PreferenceView.vue?vue&type=template&id=741bc996"
import script from "./PreferenceView.vue?vue&type=script&lang=js"
export * from "./PreferenceView.vue?vue&type=script&lang=js"
import style0 from "./PreferenceView.vue?vue&type=style&index=0&id=741bc996&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports